import { AxiosError } from 'axios';
import { validateDataResponse } from 'commons/helpers';
import {
    createApiSpec,
    getApiSpec,
    getApiSpecFiles as getApiSpecFilesDs,
    getListApiSpecs,
    uploadApiSpecFiles as uploadApiSpecFilesDs
} from 'data/datasources/v1/apiSpecs';
import { ApiPortalFile, ApiSpec, ApiSpecS3UploadResult, SaveApiSpecResponse } from 'data/schemas/apiSpec';

export async function saveApiSpec(req: ApiSpec[]) {
    try {
        await createApiSpec(req);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const result: SaveApiSpecResponse = validateDataResponse(error.response);
            throw new Error(JSON.stringify(result));
        }

        throw error;
    }
}

export async function listApiSpecs() {
    try {
        const response = await getListApiSpecs();
        const result: ApiSpec[] = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getApiSpecById(id: number) {
    try {
        const response = await getApiSpec(id.toString());
        const result: ApiSpec = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getApiSpecFiles(apiGroup: string, apiName: string): Promise<ApiPortalFile[]> {
    try {
        const response = await getApiSpecFilesDs(apiGroup, apiName);
        const result: ApiPortalFile[] = validateDataResponse(response);
        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }
        throw error;
    }
}

export async function uploadApiSpecFiles(
    files: File[],
    apiGroup: string,
    apiName: string,
    uploadBy: string
): Promise<ApiSpecS3UploadResult[]> {
    try {
        const response = await uploadApiSpecFilesDs(files, apiGroup, apiName, uploadBy);
        const result: ApiSpecS3UploadResult[] = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}
